import AboutUs from '../../components/AboutUs/AboutUs';
import BreadcrumbsComp from '../../components/Breadcrumbs/Breadcrumbs';
import Contact from '../../components/Contact/Contact';
import Cooperate from '../../components/Cooperate/Cooperate';
import styles from '../../styles/Contact.module.scss';

const Kontakt = () => {
  return (
    <div className={styles.contactContainer}>
      <div className={styles.breadcrumbsContainer}>
        <BreadcrumbsComp mainPage={true} typo={'kontakt'} />
      </div>
      <Contact />
      <Cooperate />
      <AboutUs />
    </div>
  );
};

export default Kontakt;
